import { useContext, useEffect, useState } from "react";
import { BtnCustom } from "../../../../components/button/button";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import MaskInput from "../../../../components/inputs/mask";
import SelectInput from "../../../../components/inputs/select";
import TextInput from "../../../../components/inputs/text";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import { ContextGlobal } from "../../../../context";

const FormUpdateDataStore = (props) => {
	const {
		//hooks
		handleFetchAddress,
		handleSelectedState,
		handleOnSubmit,

		//useForm
		setValue,
		setFocus,
		register,
		handleSubmit,
		control,

		//Loading
		cepIsSubmitting,
		loading,
		loadingCities,

		//formState
		reset,
		errors,
		isSubmitting,

		citiesData,
		custumerAsaas,
		brazilStates,
		// register,
		// control,
		// reset,
		// errors,

		// handleOnSubmit,
		// handleSubmit,

		// isSubmitting,
		// citiesData,
	} = IndexHook();

	const { listPermissionsData } = useContext(ContextGlobal);

	//verifica se o cliente possui demo ativo
	const [validateDemoStatus, setValidateDemoStatus] = useState(true);

	useEffect(() => {
		const sessionStatus = listPermissionsData?.status;

		setValidateDemoStatus(sessionStatus);
	}, [listPermissionsData]);

	return (
		<>
			<form className="v form" onSubmit={handleSubmit(handleOnSubmit)}>
				<header>
					<h1 className="text-2xl font-semibold text-gray-800">
						{validateDemoStatus === "EXPIRADO" && "Seu período de demonstração expirou. "}
						{/* Por favor, revise e confirme seus dados para contratar o serviço. */}
						Confirmar Dados
					</h1>
					<p className="text-xs text-gray-500">Contratar Serviço.</p>
				</header>
				<main className="mt-3">
					<div className="row">
						<TextInput
							label="Nome da Empresa"
							id="nome"
							placeholder=""
							register={register}
							errors={errors}
							onKeyDown={libForm.EnterTab}
							autoFocus={true}
							className="col-12"
						/>
						<MaskInput
							label="Cep"
							name="cep"
							control={control}
							errors={errors}
							format="#####-###"
							className="col-4 col-sm-4 col-lg-2"
							onKeyDown={libForm.EnterTab}
						/>
						<div className="col-8 d-flex align-items-center">
							<BtnCustom
								className="btn btn-sm btn-outline-primary btn-cep"
								onKeyDown={libForm.EnterTab}
								onClick={(e) => handleFetchAddress()}
								text={cepIsSubmitting ? "Buscando..." : "Buscar endereço por CEP"}
							/>
						</div>
						<TextInput
							label="Endereço"
							id="rua"
							placeholder=""
							register={register}
							errors={errors}
							onKeyDown={libForm.EnterTab}
							className="col-12 col-sm-8 col-lg-5"
						/>
						<TextInput
							label="Número"
							id="numero"
							placeholder=""
							register={register}
							errors={errors}
							onKeyDown={libForm.EnterTab}
							className="col-12 col-sm-4 col-lg-2"
						/>
						<TextInput
							label="Complemento"
							id="complemento"
							placeholder=""
							register={register}
							errors={errors}
							onKeyDown={libForm.EnterTab}
							className="col-12 col-sm-8 col-lg-2"
						/>
						<TextInput
							label="Bairro"
							id="bairro"
							placeholder=""
							register={register}
							errors={errors}
							onKeyDown={libForm.EnterTab}
							className="col-12 col-sm-6 col-lg-3"
						/>
						<SelectInput
							label="Estado"
							id="uf"
							labelSelect="nome"
							control={control}
							errors={errors}
							data={brazilStates}
							setValue={setValue}
							onKeyDown={libForm.EnterTab}
							handleSelect={handleSelectedState}
							loading={loadingCities}
							className="col-12 col-sm-6 col-lg-4"
						/>
						<SelectInput
							label="Cidade"
							id="id_cidade"
							labelSelect="nome"
							control={control}
							errors={errors}
							data={citiesData}
							setValue={setValue}
							onKeyDown={libForm.EnterTab}
							loading={loadingCities}
							className="col-12 col-sm-6 col-lg-4"
						/>
						<TextInput
							label="CPF/CNPJ"
							id="cpf"
							placeholder=""
							register={register}
							errors={errors}
							onKeyDown={libForm.EnterTab}
							className="col-12 col-sm-6 col-lg-4"
						/>

						<MaskInput
							label="Celular"
							name="telefone_1"
							control={control}
							errors={errors}
							required={false}
							format="(##)#####-####"
							className="col-6 col-sm-3 col-lg-2"
							onKeyDown={libForm.EnterTab}
							setFocus={setFocus}
						/>
						<MaskInput
							label="Telefone"
							name="telefone_2"
							control={control}
							errors={errors}
							format="(##)#####-####"
							className="col-6 col-sm-3 col-lg-2"
							onKeyDown={libForm.EnterTab}
						/>
						{/* <TextInput
							label="E-mail"
							id="email"
							placeholder=""
							register={register}
							errors={errors}
							onKeyDown={libForm.EnterTab}
							className="col-12 col-sm-6 col-lg-8"
						/> */}
					</div>
				</main>

				{/* Botões */}
				<footer>
					<div className="flex justify-between">
						{/* <button
											type="button"
											className="btn btn-secondary"
											onClick={() => setStage(stage - 1)}
										>
											Voltar
										</button> */}
						<BtnSubmit
							text="Atualizar dados cadastrais"
							className="btn btn-primary w-64"
							isSubmitting={isSubmitting}
						/>
					</div>
				</footer>
			</form>
		</>
	);
};

export default FormUpdateDataStore;
